var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgtweet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7486 18.5013L26.9943 12H24.653L20.6491 16.9653L17.0971 12H12L17.9474 20.3124L12.3581 27.2381H14.7002L19.0469 21.8514L22.9029 27.2381H28L21.7486 18.5013ZM19.9352 20.749L18.8343 19.2107L14.56 13.2396H16.32L19.7699 18.0526L20.8693 19.5916L25.4545 25.9985H23.6945L19.9352 20.749Z",
    fill: "#0C1C2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgtweet);
export default __webpack_public_path__ + "static/media/Imgtweet.e0a35f794d252a61bece71341efce67c.svg";
export { ForwardRef as ReactComponent };